export default "__VITE_ASSET__HUXbgLN7__"